import { h, Component } from 'preact';
import { joinClasses } from 'utils/utils';

import s from 'components/media/addMediaButton.sss';

export default class AddMediaButton extends Component {
	render(props) {
		return (
			<button class={joinClasses(s.addMediaButton, props.dark && s.dark)} disabled={props.disabled} onClick={props.onClick}>
				<div>Upload media</div>
			</button>
		);
	}
}
